// extracted by mini-css-extract-plugin
module.exports = {"addNew":"AddNew_addNew__79Mju","error":"AddNew_error__3r9r1","submitPlc":"AddNew_submitPlc__10oye","disabled":"AddNew_disabled__yThyV"};